import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { UiHelper } from '../../common/helpers/UiHelper';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { ApiHelperV2 } from '../helpers/ApiHelperV2';
import { Helper } from '../helpers/Helper';
import { Controller } from '../Controller';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { AppTheme } from '../../styles/AppTheme';
import { AppHelper } from '../../helpers/AppHelper.js'
import Zoom from 'react-img-zoom';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

const HEADERVALUE = 49;
const CONTROLVALUE = 61;
const FOOTERVALUE = 95;
const TOTALVALUE = HEADERVALUE + CONTROLVALUE + FOOTERVALUE
export class EventDialogFunction extends Component {
  constructor(props) {
    super(props);
    this.pause = true;
    this.play = false;
    this.playerFnId = null;
    this.jpegPlayerRefreshInterval = AppConfig.jpegPlayerRefreshInterval;
    this.state = {
      zoomScale: 0,
      errMsg: null,
      eventIndex: this.props.eventIndex,
      dialogEdit: null,
      open: false,
      player: 'play_arrow',
      fullScreen: true,
      eventImgMaxHeight: 0
    }
  }

  dialogEditClose = () => {
    this.setState({ dialogEdit: null, open: false });
  };

  handleClose = (event, priority) => {
    this.setState({ open: false });
    const options = {
      method: 'POST',
      endPoint: ApiHelperV2.makeUrlPath(['events', this.props.eventData[this.state.eventIndex]._id]),
      jsonBody: {
        priority: Number(priority)
      }
    }
    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        //const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: 'An error occured.',
          errCode: err.respCode,
        })
        return
      }
      this.setState({
        errMsg: null
      })
      this.props.setEventData(this.state.eventIndex, Number(priority))
      //this.props.eventData[this.state.eventIndex].priority = Number(priority)
    }.bind(this))
  };

  handleToggle = (event) => {
    //console.log('handleToggle: event.target', event.target)
    this.setState({ open: !this.state.open });
    this.setState({ dialogEdit: event.currentTarget })
  }

  onDelete = () => {
    const options = {
      method: 'DELETE',
      endPoint: ApiHelperV2.makeUrlPath(['events', this.props.eventData[this.state.eventIndex]._id]),
    }
    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        //const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: 'An error occured.',
          errCode: err.respCode,
        })
        return
      }
      this.setState({
        errMsg: null
      })
      this.props.dialogClose(true)
    }.bind(this))
  }

  sliderFunction = (e) => {
    this.setState({
      zoomScale: e
    })
  }

  onPlay() {
    //console.log("onClickPlayer...");
    if (this.play) {
      this.play = false;
      this.pause = true;
      this.setState({
        player: 'play_arrow'
      })
      if (this.playerFnId) {
        clearInterval(this.playerFnId);
      }
    } else {
      this.pause = false;
      this.play = true;
      this.setState({
        player: 'pause'
      })
      this.playerFnId = setInterval(() => {
        this.dialogNextV2();
      }, this.jpegPlayerRefreshInterval);
    }
  }

  dialogFirst = () => {
    this.setState({ eventIndex: 0 })
  }

  dialogLast = () => {
    const lastValue = this.props.eventData.length - 1
    this.setState({ eventIndex: lastValue })
  }
  dialogNext = (index) => {
    const value = index + 1
    this.setState({ eventIndex: value })
  }
  dialogNextV2 = () => {
    if (this.state.eventIndex === (this.props.eventData.length - 1)) {
      if (this.play) {
        this.onPlay()
      }
      return;
    }
    this.setState({ eventIndex: (this.state.eventIndex + 1) })
  }

  dialogBefore = (index) => {
    const value = index - 1
    this.setState({ eventIndex: value })
  }

  fullScreen = () => {
    let dialogElementsHeight = 0;

    if (document.getElementById('action') && document.getElementById('action').offsetHeight) {
      dialogElementsHeight = dialogElementsHeight + document.getElementById('action').offsetHeight
    }
    if (document.getElementById('detail') && document.getElementById('action').offsetHeight) {
      dialogElementsHeight = dialogElementsHeight + document.getElementById('action').offsetHeight
    }
    if (document.getElementById('title') && document.getElementById('action').offsetHeight) {
      dialogElementsHeight = dialogElementsHeight + document.getElementById('action').offsetHeight
    }

    let eventImgMaxHeight = this.state.eventImgMaxHeight;

    if (dialogElementsHeight) {
      eventImgMaxHeight = window.innerHeight - dialogElementsHeight - 50;
    }

    this.setState({ fullScreen: !this.state.fullScreen, eventImgMaxHeight: eventImgMaxHeight })
  }

  componentDidMount() {
    this.setState({
      eventIndex: this.props.eventIndex,
      eventImgMaxHeight: window.innerHeight - TOTALVALUE - 20
    })
  }

  onKeyPressed = (ev, item) => {
    if (ev.key === 'ArrowRight') {
      item < this.props.eventData.length - 1 &&
        this.dialogNext(item)
    }
    if (ev.key === 'ArrowLeft') {
      item > 0 &&
        this.dialogBefore(item)
    }
    if (ev.keyCode === 32) {
      this.onPlay()
    }
  }

  render() {
    const heightVal = this.state.eventImgMaxHeight < 720 ? this.state.eventImgMaxHeight : 720
    const DynamicStyles = StyleSheet.create({
      eventImageContentFullscreen: {
        width: '100%',
        height: heightVal,
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'black',
        alignItems: 'center'
      },
      carouselFullscreen: {
        maxWidth: this.state.eventImgMaxHeight < 720 ? (this.state.eventImgMaxHeight * 1.78) : 1280
      }
    })
    return (
      <Dialog
        onClose={() => this.props.dialogClose(false)}
        open={this.props.eventDialog}
        scroll='paper'
        classes={{
          paperWidthSm: this.state.fullScreen ? css(Styles.dialogFullScreen) : css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
        onKeyDown={ev => this.onKeyPressed(ev, this.state.eventIndex)}
      >
        <div id='title' className={css(Styles.dialogTitle)} >
          <p className={css(Styles.dialogTitleContent)}>Events</p>
          <div className={css(Styles.dialogCloseButton)}>
            <Icon className={css(Styles.closeIcon)} color='secondary' onClick={() => this.props.dialogClose(false)}>
              cancel
            </Icon>
          </div>
        </div>
        <DialogContent className={this.state.fullScreen ? css(Styles.dialogContentFullscreen) : css(Styles.dialogContent)}>
          {this.props.eventData.map((item, index) => {
            return (
              index === this.state.eventIndex &&
              <div key={item._id}>
                {item.additionalImages && item.additionalImages.length > 0 ?
                  <Carousel showArrows={false} showThumbs={false} showStatus={false} infiniteLoop={true} emulateTouch={true}
                    className={this.state.fullScreen ? css(DynamicStyles.carouselFullscreen) : css(Styles.carousel)} stopOnHover={false}>
                    <div className={this.state.fullScreen ? css(DynamicStyles.eventImageContentFullscreen) : css(Styles.eventImageContent)}
                    >
                      {AppConfig.zoomFeature &&
                        <Zoom
                          img={item.image}
                          zoomScale={this.state.zoomScale + 1}
                          width={(this.props.cam.streamContentWidth * heightVal) / this.props.cam.streamContentHeight}
                          height={heightVal}
                        />
                      }
                      {!AppConfig.zoomFeature &&
                        <img src={item.image} className={this.state.fullScreen ? css(Styles.eventImageFullscreen) : css(Styles.eventImage)} />
                      }
                    </div>
                    {item.additionalImages.map(image => {
                      return (
                        <div className={this.state.fullScreen ? css(DynamicStyles.eventImageContentFullscreen) : css(Styles.eventImageContent)}>
                          {AppConfig.zoomFeature &&
                            <Zoom
                              img={image}
                              zoomScale={this.state.zoomScale + 1}
                              width={(this.props.cam.streamContentWidth * this.state.eventImgMaxHeight) / this.props.cam.streamContentHeight}
                              height={this.state.eventImgMaxHeight}
                            />
                          }
                          {!AppConfig.zoomFeature &&
                            <img src={image} className={this.state.fullScreen ? css(Styles.eventImageFullscreen) : css(Styles.eventImage)} />
                          }
                        </div>
                      )
                    })}
                  </Carousel>
                  :
                  <div className={this.state.fullScreen ? css(DynamicStyles.eventImageContentFullscreen) : css(Styles.eventImageContent)}>
                    {!AppConfig.zoomFeature &&
                      <img src={item.image} className={this.state.fullScreen ? css(Styles.eventImageFullscreen) : css(Styles.eventImage)} />
                    }
                    {AppConfig.zoomFeature &&
                      <Zoom
                        img={item.image}
                        zoomScale={this.state.zoomScale + 1}
                        width={(this.props.cam.streamContentWidth * heightVal) / this.props.cam.streamContentHeight}
                        height={heightVal}
                      />
                    }
                  </div>
                }
                <div id='action' className={css(Styles.eventControlContent)}>
                  <div className={css(Styles.eventControlContainer)}>
                    <IconButton color='secondary' disabled={this.state.eventIndex === 0 ? true : false}
                      className={css(Styles.iconButton)}>
                      <Icon
                        className={this.state.eventIndex === 0 ?
                          css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                        color='secondary' onClick={() => this.dialogFirst()}>
                        first_page
                      </Icon>
                    </IconButton>
                    <IconButton color='secondary' disabled={this.state.eventIndex === 0 ? true : false}
                      className={css(Styles.iconButton)}>
                      <Icon
                        className={this.state.eventIndex === 0 ?
                          css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                        color='secondary' onClick={() => this.dialogBefore(index)}>
                        navigate_before
                      </Icon>
                    </IconButton>
                    <Icon className={css(Styles.eventControlIcon)} color='secondary' onClick={() => this.onPlay()}>
                      {this.state.player}
                    </Icon>
                    <IconButton color='secondary'
                      disabled={this.state.eventIndex === this.props.eventData.length - 1 ? true : false}
                      className={css(Styles.iconButton)}>
                      <Icon
                        className={this.state.eventIndex === this.props.eventData.length - 1 ?
                          css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                        color='secondary' onClick={() => this.dialogNext(index)}>
                        navigate_next
                      </Icon>
                    </IconButton>
                    <IconButton color='secondary'
                      disabled={this.state.eventIndex === this.props.eventData.length - 1 ? true : false}
                      className={css(Styles.iconButton)}>
                      <Icon
                        className={this.state.eventIndex === this.props.eventData.length - 1 ?
                          css(Styles.eventControlIcon, Styles.eventControlIconSelected) : css(Styles.eventControlIcon)}
                        color='secondary' onClick={() => this.dialogLast()}>
                        last_page
                      </Icon>
                    </IconButton>

                  </div>
                  {/* <IconButton color='secondary'
                    className={css(Styles.iconButton)}>
                    <Icon
                      className={css(Styles.eventControlIcon)}
                      color='secondary' onClick={() => this.fullScreen()}>
                      fullscreen
                    </Icon>
                  </IconButton> */}
                  {/*this.props.dialogVideo &&
                    <Icon className={css(Styles.eventControlIcon)} color='secondary' onClick={() => this.props.dialogVideo(item)}>
                      videocam
                    </Icon>
                  */}

                  {AppConfig.zoomFeature &&
                    <div className={css(Styles.SliderOuterContainer)}>
                      <div className={css(Styles.sliderTitle)}>Zoom {this.state.zoomScale === 0 ? 'off' : this.state.zoomScale + 'x'}</div>
                      <Slider
                        min={0}
                        max={3}
                        defaultValue={this.state.zoomScale}
                        step={1}
                        className={css(Styles.sliderContainer)}
                        railStyle={{ backgroundColor: '#000', height: 14, opacity: .38 }}
                        trackStyle={{ backgroundColor: AppTheme.secondaryColor, height: 14, opacity: 1 }}
                        handleStyle={{
                          borderColor: '#fafafa',
                          height: 21,
                          width: 21,
                          marginLeft: 0,
                          marginTop: -3,
                          backgroundColor: '#fafafa',
                          boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)'
                        }}
                        onChange={this.sliderFunction}
                      />
                    </div>
                  }
                </div>
                <Divider />
                <div id='detail' className={css(Styles.eventDetailContent)}>
                  <div className={css(Styles.eventListTitleConatiner)}>
                    <p className={css(Styles.eventListTitle)}>{item.name}</p>
                    <p className={css(Styles.eventListTitle)}>{moment(item.event_time).format('MMM DD, YYYY, h:mm:ss A')}</p>
                    {item.priorityReported !== undefined && Controller.get().userMgrV2().isAdminUser() &&
                      <div className={css(Styles.reportPriority)}>
                        <p className={css(Styles.eventReportPriority)}>Reported priority</p>
                        <div className={css(Styles.eventPriorityValue)}>{AppHelper.getPriorityStr(item.priorityReported)}</div>
                      </div>
                    }
                  </div>
                  <div className={css(Styles.eventListTitleConatiner, Styles.eventListTitleSecondConatiner)}>
                    <div className={css(Styles.eventTypeContent)}>
                      {item.type &&
                        <div className={css(Styles.eventType)}>{item.type}</div>
                      }
                    </div>
                    <div className={css(Styles.eventTypeConatiner)}>
                      {this.state.errMsg &&
                        <p className={css(Styles.errMsg)}>{this.state.errMsg}</p>
                      }
                      {Controller.get().userMgrV2().isAdminUser() &&
                        <Icon className={css(Styles.icons)} color='secondary' onClick={() => this.onDelete()}>
                          delete
                        </Icon>
                      }
                      {Controller.get().userMgrV2().isAdminUser() &&
                        <Icon className={css(Styles.icons)} color='secondary' onClick={this.handleToggle}>
                          create
                        </Icon>
                      }
                      {Controller.get().userMgrV2().isAdminUser() &&
                        <Menu
                          id='long-menu'
                          anchorEl={this.state.dialogEdit}
                          open={this.state.open}
                          onClose={this.dialogEditClose}
                        >
                          {this.props.priority.map((item, index) => (
                            <MenuItem key={item.value} onClick={event => this.handleClose(event, item.value)} className={css(Styles.dialogEditItems)}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </Menu>
                      }
                      <div className={css(Styles.eventPriority)}
                        style={{ backgroundColor: AppHelper.getPriotiyColor(item.priority) }}
                      >{AppHelper.getPriorityStr(item.priority)}</div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </DialogContent>
        <div>
        </div>
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  dialog: {
    width: 500,
  },
  dialogFullScreen: {
    maxWidth: 1280,
    maxHeight: window.innerHeight,
    margin: 0,
  },
  dialogTitle: {
    padding: '0px 10px',
    backgroundColor: AppTheme.secondaryBg,
    display: 'flex',
    minHeight: 20,
    alignItems: 'center',
    height: HEADERVALUE
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 23,
    margin: 0,
    color: 'black'
  },
  dialogCloseButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    alignItems: 'center'
  },
  closeIcon: {
    color: 'black',
    cursor: 'pointer'
  },
  dialogContent: {
    padding: 0,
    overflow: 'hidden'
  },
  dialogContentFullscreen: {
    padding: 0,
  },
  eventImageContent: {
    width: '100%',
    height: 'auto',
    //minHeight: 300,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'black',
    alignItems: 'center'
  },
  eventImage: {
    width: '100%',
    //maxHeight: '100%'
  },
  eventImageFullscreen: {
    //maxHeight: '100%'
    height: '100%',
    width: 'auto'
  },
  eventControlContent: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0px 10px',
    minHeight: 40,
    alignItems: 'center',
    height: CONTROLVALUE,
  },
  eventControlContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 90,
  },
  iconButton: {
    padding: 0,
  },
  eventControlIcon: {
    borderRadius: '50%',
    color: 'white',
    backgroundColor: '#303E8A',
    padding: 8,
    fontSize: 25,
    cursor: 'pointer',
    marginRight: 10
  },
  eventControlIconSelected: {
    backgroundColor: '#D7D7D7',
    color: '#9F9F9F',
  },
  eventDetailContent: {
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    minHeight: 75,
    height: FOOTERVALUE
  },
  eventListTitleConatiner: {
    display: 'flex',
    flexDirection: 'column',
  },
  eventListTitleSecondConatiner: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  reportPriority: {
    display: 'flex',
    alignItems: 'center'
  },
  eventReportPriority: {
    margin: 0,
    fontSize: 14,
    fontWeight: 'bold'
  },
  eventListTitle: {
    margin: 0,
    marginBottom: 5,
    fontSize: 14,
    fontWeight: 'bold'
  },
  eventTypeConatiner: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1
  },
  eventTypeContent: {
    minHeight: 28
  },
  eventType: {
    backgroundColor: '#FF4081',
    color: 'white',
    borderRadius: 15,
    fontSize: 12,
    padding: 7,
    marginBottom: 10,
  },
  eventPriorityValue: {
    backgroundColor: 'gray',
    color: 'white',
    borderRadius: 15,
    fontSize: 12,
    padding: 7,
    marginLeft: 10
  },
  eventPriority: {
    color: 'white',
    borderRadius: 15,
    fontSize: 12,
    padding: 7,
    marginLeft: 10,
    fontWeight: 'bold'
  },
  eventListDate: {
    margin: 0,
    marginBottom: 5,
    fontSize: 13,
    fontWeight: 600
  },
  icons: {
    marginLeft: 10,
    cursor: 'pointer',
    color: 'black'
  },
  link: {
    textDecoration: 'none'
  },
  dialogEditItems: {
    fontWeight: 600,
  },
  errMsg: {
    color: 'red',
    margin: 0,
    paddingRight: 5,
    fontWeight: 'bold'
  },
  SliderOuterContainer: {
    //backgroundColor: 'whitesmoke',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    //paddingRight: 10,
    //paddingLeft: 10,
    width: 90,
    //marginRight: 30,
  },
  sliderContainer: {
    width: 55,
    padding: 0
  },
  sliderTitle: {
    fontSize: 12,
    margin: 5,
  },
  fillSpace: {
    flex: 1
  }
})



// WEBPACK FOOTER //
// ./src/common/components/EventDialogFunction.js